import { Cache } from '@common/utils'
import { getEnv } from './env'

export const cache = new Cache({ prefix: getEnv().VUE_APP_NAME })
export const Storage = cache
export default cache
